import React from "react";

interface PhonePreviewProps {
  children?: React.ReactNode;
}

const PhonePreview: React.FC<PhonePreviewProps> = ({ children }) => {
  const time = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return (
    <div className="w-80 h-[600px] bg-gray-100 rounded-3xl overflow-hidden flex flex-col shadow-2xl">
      {/* Header */}
      <div className="w-full bg-black text-white flex items-center justify-between px-4 py-1">
        <div className="text-xs">{time}</div>
        <div className="flex items-center gap-1">
          <div className="w-4 h-2 bg-gray-100 rounded-full"></div>
          <div className="w-4 h-2 bg-gray-100 rounded-full"></div>
          <div className="w-4 h-2 bg-gray-100 rounded-full"></div>
        </div>
      </div>
      {/* Body */}
      <div className="w-full h-120 bg-[#F9F6FF] rounded-md flex-1 overflow-y-auto">
        {children}
      </div>
      {/* Footer */}
      <div className="bg-white h-5"></div>
    </div>
  );
};

export default PhonePreview;
